import React, { useContext, useState } from "react";
import { SidebarContext } from "context/SidebarContext";
import FranchiseServices from "services/FranchiseService";
import { notifySuccess } from "utils/toast";
import ConfirmFranchiseModal from "components/form/ConfirmFranchiseModal";

const FranchiseStatus = ({ id, accountStatus, title_block }) => {
  const { setIsUpdate, setFunctionLoading } = useContext(SidebarContext);
  const [showBlockModal, setShowBlockModal] = useState(false);

  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id || 0;

  // Determine current status: 0 = Inactive, 1 = Active, 2 = Blocked
  const currentStatus = accountStatus;

  // const handleChangeStatus = () => {
  //   setShowBlockModal(true);
  // };

  const handleChangeStatus = () => {
    setShowBlockModal(true);
  };
  const handleUpdateBlock = async (remark, account_status) => {
    setShowBlockModal(false);
    setFunctionLoading(true);

    try {
      const payload = {
        account_status,
      };

      // Only send remark for inactive or blocked
      if (account_status === "inactive" || account_status === "blocked") {
        payload.remark = remark;
      }

      await FranchiseServices.updateFranchiseStatus(id, payload);

      notifySuccess(`${title_block} status updated successfully`);
      setIsUpdate(true);
    } catch (err) {
      console.error(err);
    } finally {
      setFunctionLoading(false);
    }
  };
  // Define options dynamically based on current status
  const getStatusOptions = () => {
    switch (currentStatus) {
      case "active":
        return [
          { value: "inactive", label: "Inactive" },
          { value: "blocked", label: "Block" },
        ];

      case "inactive":
        return [{ value: "active", label: "Active" }];

      case "blocked":
        return [{ value: "active", label: "Unblock" }];

      default:
        return [];
    }
  };

  return (
    <>
      <span
        className="text-sm cursor-pointer text-blue-500 focus:outline-none"
        style={{ fontSize: "11px" }}
        onClick={handleChangeStatus}
      >
        Change
      </span>
      <ConfirmFranchiseModal
        isOpen={showBlockModal}
        status={currentStatus}
        statusOptions={getStatusOptions()}
        onClose={() => setShowBlockModal(false)}
        onConfirm={handleUpdateBlock}
        showRemark={currentStatus === "active"}
      />
    </>
  );
};

export default FranchiseStatus;
